import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'HTKit/Icon';
import styles from './styles.scss';

const SkuNotice = ({ handleClick, visible }) => {
  const iconName = visible ? 'arrow-up' : 'arrow-down';

  return (
    <button className={`plainButton ${styles.skuButton}`} onClick={handleClick}>
      Important Service Tips
      <Icon name={iconName} className={`paddingLeft-tiny ${styles.arrow}`} />
    </button>
  );
};

SkuNotice.propTypes = {
  visible: PropTypes.bool,
  handleClick: PropTypes.func.isRequired,
};

export default SkuNotice;
